import Colors from '../../../../shared/assets/style/default/color';
import styled from 'styled-components';

const AdsContainer = styled.div<{ transparent?: boolean }>`
  background: ${(props) =>
    props.transparent ? 'transparent' : Colors.background};
  height: 100%;
  overflow: hidden;
  position: absolute;
  width: 100vw;
`;

export default AdsContainer;
